let link2 = window.location.origin + RemoveLastDirectoryPartOf( RemoveLastDirectoryPartOf(window.location.pathname ) ) + "/";

const dev={
 
    SITE_URL: 'https://site.xsa/en/', 
    API_URL: 'https://site.xsa/en/api/', 
    'type': 'dev'
}

const prod={
 
    SITE_URL: window.location.origin ,
    // API_URL: 'https://top-escort-geneva.com/en/api/', 
    API_URL: 'https://xspartner.com/en/api/', 
    // API_URL: 'https://xsagency.com/en/api/', 
    // API_URL: 'https://site.xsa/en/api/', 
    'type': 'prod'
}
 

const config=process.env.NODE_ENV=='development'?dev:prod

console.log( "config: ", config); 

function RemoveLastDirectoryPartOf(the_url)
{
    var the_arr = the_url.split('/');
    the_arr.pop();
    return( the_arr.join('/') );
}

export default  config